var map = {
	"./discover": 8055,
	"./discover.js": 8055,
	"./friends": 6761,
	"./friends/": 6761,
	"./friends/index": 6761,
	"./friends/index.jsx": 6761,
	"./group": 9737,
	"./group/": 9737,
	"./group/ButtonActionGroup": 3384,
	"./group/ButtonActionGroup/": 3384,
	"./group/ButtonActionGroup/index": 3384,
	"./group/ButtonActionGroup/index.jsx": 3384,
	"./group/[id]": 7948,
	"./group/[id].jsx": 7948,
	"./group/components/GroupIntroduce": 29,
	"./group/components/GroupIntroduce.jsx": 29,
	"./group/components/GroupMember": 8411,
	"./group/components/GroupMember.jsx": 8411,
	"./group/components/GroupPost": 6829,
	"./group/components/GroupPost.jsx": 6829,
	"./group/components/ListPostInGroup": 77,
	"./group/components/ListPostInGroup.jsx": 77,
	"./group/form-add-group": 1959,
	"./group/form-add-group/": 1959,
	"./group/form-add-group/index": 1959,
	"./group/form-add-group/index.css": 1382,
	"./group/form-add-group/index.js": 1959,
	"./group/friend-group": 7523,
	"./group/friend-group/": 7523,
	"./group/friend-group/index": 7523,
	"./group/friend-group/index.css": 739,
	"./group/friend-group/index.jsx": 7523,
	"./group/index": 9737,
	"./group/index.css": 3493,
	"./group/index.jsx": 9737,
	"./group/my-group": 3586,
	"./group/my-group/": 3586,
	"./group/my-group/index": 3586,
	"./group/my-group/index.jsx": 3586,
	"./home": 8704,
	"./home/": 8704,
	"./home/discover": 3507,
	"./home/discover/": 3507,
	"./home/discover/index": 3507,
	"./home/discover/index.jsx": 3507,
	"./home/index": 8704,
	"./home/index.jsx": 8704,
	"./login": 322,
	"./login.js": 322,
	"./market": 2380,
	"./market/": 2380,
	"./market/[id]": 8356,
	"./market/[id].js": 8356,
	"./market/index": 2380,
	"./market/index.jsx": 2380,
	"./message": 3501,
	"./message/": 3501,
	"./message/[id]": 7107,
	"./message/[id].js": 7107,
	"./message/index": 3501,
	"./message/index.js": 3501,
	"./post/[id]": 5099,
	"./post/[id].js": 5099,
	"./profile/[id]": 2705,
	"./profile/[id].js": 2705,
	"./register": 4718,
	"./register.js": 4718,
	"./shop": 524,
	"./shop/": 524,
	"./shop/EditTravelPackageModal": 2531,
	"./shop/EditTravelPackageModal.jsx": 2531,
	"./shop/ProductCard": 1098,
	"./shop/ProductCard.jsx": 1098,
	"./shop/TravelPackageModal": 9364,
	"./shop/TravelPackageModal.jsx": 9364,
	"./shop/index": 524,
	"./shop/index.jsx": 524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2150;